import { render, staticRenderFns } from "./Lucky.vue?vue&type=template&id=139ff93c&scoped=true&"
import script from "./Lucky.vue?vue&type=script&lang=js&"
export * from "./Lucky.vue?vue&type=script&lang=js&"
import style0 from "./Lucky.vue?vue&type=style&index=0&id=139ff93c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139ff93c",
  null
  
)

export default component.exports